import { create } from 'zustand';

interface FocusStore {
  /**
   * Distraction-free ("zen") view toggle. Held here — outside GameScreen — so it
   * survives the component remounts caused by a rematch or starting a new game
   * within the same session. It resets to `false` only on a full app reload
   * (no persistence): switching it off is otherwise the user's decision, via the
   * Focus/Esci button in the in-game toolbar.
   */
  isFocusOn: boolean;
  toggleFocus: () => void;
  setFocusOn: (on: boolean) => void;
}

export const useFocusStore = create<FocusStore>((set) => ({
  isFocusOn: false,
  toggleFocus: () => set((s) => ({ isFocusOn: !s.isFocusOn })),
  setFocusOn: (isFocusOn) => set({ isFocusOn }),
}));
